import axiosInstance from 'api/axiosInstance';

export const authService = {
  logOut: async (): Promise<{ success: boolean }> => {
    const response = await axiosInstance.post<{ success: boolean }>(
      `/users/logout`,
    );
    return response.data;
  },

  verifyToken: async (): Promise<boolean> => {
    const response = await axiosInstance.get('/users/me/profil');
    return response.status === 200 && response.data.success === true;
  },
};
